import { FppFilterSettings } from "@/features/search-filter/types/FppFilterSettings";

export const statisticsByRouteFilterSettings: FppFilterSettings = {
  routePairEnabled: true,
  routePairHeader: "Routes",
};
